<script setup>
import { ref } from 'vue'

const selectedMonth = ref(5) // 默认选择5月
const months = ref([
  { id: 1, name: '1月' },
  { id: 2, name: '2月' },
  { id: 3, name: '3月' },
  { id: 4, name: '4月' },
  { id: 5, name: '5月' },
  { id: 6, name: '6月' },
  { id: 7, name: '7月' },
  { id: 8, name: '8月' },
  { id: 9, name: '9月' },
  { id: 10, name: '10月' },
  { id: 11, name: '11月' },
  { id: 12, name: '12月' }
])

const files = ref([
  { id: 1, name: '图片1.png', type: 'image', icon: '🖼️' },
  { id: 2, name: '图片2.png', type: 'image', icon: '🖼️' },
  { id: 3, name: '图片3.png', type: 'image', icon: '🖼️' },
  { id: 4, name: '图片4.png', type: 'image', icon: '🖼️' },
  { id: 5, name: '图片5.png', type: 'image', icon: '🖼️' },
  { id: 6, name: '图片6.png', type: 'image', icon: '🖼️' },
  { id: 7, name: '图片7.png', type: 'image', icon: '🖼️' },
  { id: 8, name: '图片8.png', type: 'image', icon: '🖼️' },
  { id: 9, name: '图片9.png', type: 'image', icon: '🖼️' },
  { id: 10, name: '图片10.png', type: 'image', icon: '🖼️' }
])

const selectMonth = (monthId) => {
  selectedMonth.value = monthId
}

const handleFileClick = (file) => {
  console.log('点击文件:', file.name)
}
</script>

<template>
  <div class="file-management">
    <!-- 页面标题 -->
    <div class="page-header">
      <h1 class="page-title">文件管理</h1>
      <p class="page-description">管理和查看您的文件资源</p>
    </div>
    
    <!-- 月份选择器 -->
    <div class="month-selector">
      <button 
        v-for="month in months" 
        :key="month.id"
        @click="selectMonth(month.id)"
        class="month-btn"
        :class="{ active: selectedMonth === month.id }"
      >
        {{ month.name }}
      </button>
    </div>
    
    <!-- 文件网格 -->
    <div class="file-grid">
      <div 
        v-for="file in files" 
        :key="file.id"
        @click="handleFileClick(file)"
        class="file-item"
      >
        <div class="file-icon">
          {{ file.icon }}
        </div>
        <div class="file-name">
          {{ file.name }}
        </div>
      </div>
    </div>
    
    <!-- 空状态提示 -->
    <div v-if="files.length === 0" class="empty-state">
      <div class="empty-icon">📁</div>
      <div class="empty-text">暂无文件</div>
    </div>
  </div>
</template>

<style scoped>
.file-management {
  width: 100%;
  height: 100%;
}

.page-header {
  margin-bottom: 30px;
  padding-bottom: 20px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
}

.page-title {
  font-size: 28px;
  font-weight: 700;
  color: #2c3e50;
  margin: 0 0 8px 0;
}

.page-description {
  font-size: 16px;
  color: #7f8c8d;
  margin: 0;
}

.month-selector {
  display: flex;
  gap: 10px;
  margin-bottom: 30px;
  flex-wrap: wrap;
}

.month-btn {
  padding: 8px 16px;
  border: none;
  border-radius: 20px;
  background: rgba(255, 255, 255, 0.8);
  color: #7f8c8d;
  cursor: pointer;
  transition: all 0.3s ease;
  font-size: 14px;
  font-weight: 500;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.month-btn:hover {
  background: rgba(102, 126, 234, 0.1);
  color: #667eea;
  transform: translateY(-2px);
}

.month-btn.active {
  background: linear-gradient(135deg, #667eea, #764ba2);
  color: white;
  box-shadow: 0 4px 15px rgba(102, 126, 234, 0.3);
}

.file-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
  gap: 20px;
  margin-bottom: 30px;
}

.file-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px;
  background: rgba(255, 255, 255, 0.6);
  border-radius: 15px;
  cursor: pointer;
  transition: all 0.3s ease;
  border: 2px solid transparent;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.08);
}

.file-item:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);
  border-color: rgba(102, 126, 234, 0.3);
  background: rgba(255, 255, 255, 0.8);
}

.file-icon {
  font-size: 48px;
  margin-bottom: 10px;
  filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.1));
}

.file-name {
  font-size: 12px;
  color: #2c3e50;
  text-align: center;
  word-break: break-all;
  line-height: 1.4;
  font-weight: 500;
}

.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
  color: #bdc3c7;
}

.empty-icon {
  font-size: 64px;
  margin-bottom: 16px;
  opacity: 0.6;
}

.empty-text {
  font-size: 16px;
  font-weight: 500;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .file-grid {
    grid-template-columns: repeat(auto-fill, minmax(120px, 1fr));
    gap: 15px;
  }
  
  .month-selector {
    gap: 8px;
  }
  
  .month-btn {
    padding: 6px 12px;
    font-size: 12px;
  }
  
  .page-title {
    font-size: 24px;
  }
  
  .page-description {
    font-size: 14px;
  }
}
</style>